import {IackathonSaveAttributes} from './iackathon-save.attributes';
import {
    IackathonDeliverableModerationStatus,
    IackathonSaveState
} from './iackathon-save.state';

export type IackathonDeliverableModerationFilter = IackathonDeliverableModerationStatus | 'all';

export type IackathonSaveLike = {
    id: string;
    attributes: IackathonSaveAttributes;
};

const DEFAULT_MODERATION_STATUS: IackathonDeliverableModerationStatus = 'pending';

export function getDeliverableModerationStatus(
    attributes: Pick<IackathonSaveAttributes, 'moderationStatus'>
): IackathonDeliverableModerationStatus {
    return attributes.moderationStatus ?? DEFAULT_MODERATION_STATUS;
}

export function isDeliverableVisibleToLearners(save: IackathonSaveLike): boolean {
    return hasDisplayableDeliverable(save.attributes.content.state)
        && getDeliverableModerationStatus(save.attributes) === 'approved';
}

export function hasDisplayableDeliverable(state: IackathonSaveState): boolean {
    return !!state.deliverable?.url;
}

export function applyDeliverableModerationStatus(
    attributes: IackathonSaveAttributes,
    status: IackathonDeliverableModerationStatus,
): IackathonSaveAttributes {
    return {
        ...attributes,
        moderationStatus: status,
    };
}

export function filterTrainerDeliverableSaves<T extends IackathonSaveLike>(
    saves: T[],
    filter: IackathonDeliverableModerationFilter = 'all'
): T[] {
    return sortTrainerDeliverableSaves(
        saves.filter(save => {
            const matchesFilter = filter === 'all' || getDeliverableModerationStatus(save.attributes) === filter;

            return hasDisplayableDeliverable(save.attributes.content.state) && matchesFilter;
        })
    );
}

export function filterLearnerDeliverableSaves<T extends IackathonSaveLike>(saves: T[]): T[] {
    return sortLearnerDeliverableSaves(
        saves.filter(save => isDeliverableVisibleToLearners(save))
    );
}

function sortTrainerDeliverableSaves<T extends IackathonSaveLike>(saves: T[]): T[] {
    return saves.slice().sort((first, second) => {
        return second.attributes.changed - first.attributes.changed;
    });
}

function sortLearnerDeliverableSaves<T extends IackathonSaveLike>(saves: T[]): T[] {
    return saves.slice().sort((first, second) => {
        return second.attributes.changed - first.attributes.changed;
    });
}
